module.exports = __webpack_public_path__ + "img/emblem.f86be470.png";